var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eb-notification-group",style:({ top: _vm.top + 'px' })},[(_vm.isMounted)?_c('transition-group',{attrs:{"name":"eb-fade-left"}},_vm._l((_vm.notifications),function(notification){return _c('Notification',{key:notification.id,attrs:{"notification":notification}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }